import '@instructure/canvas-theme';
import { Alert } from '@instructure/ui-alerts';
import { CondensedButton } from '@instructure/ui-buttons';
import { Button } from '@instructure/ui-buttons/es/Button';
import { Checkbox } from '@instructure/ui-checkbox';
import { FormField, FormFieldGroup } from '@instructure/ui-form-field';
import { Link } from '@instructure/ui-link';
import { Modal } from '@instructure/ui-modal';
import { Table } from '@instructure/ui-table';
import { Pagination } from '@instructure/ui-pagination';
import { View } from '@instructure/ui-view';
import { Tooltip } from '@instructure/ui-tooltip';
import { IconEditLine } from '@instructure/ui-icons'
import { Text } from '@instructure/ui-text'
import React, { useEffect, useState } from 'react';
import { instance } from '../axios';
import imgURL from '../images/c1-empt.svg';
import { search2query, setToken } from '../utils/store';
import EmailInfo from './EmailInfo';
import RecommendedThesis from './RecommendedThesis';
import EditInput from './EditInput';
import courseConfig from '../utils/courseConfig';
import '../css/styles.css';

function GuidePapers(props) {
  const [alertToggle, setAlertToggle] = useState('none');
  const [alerts, setAlerts] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsIds, setRowsIds] = useState([]);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [ghId, setGhId] = useState();
  const [openDetail, setOpenDetail] = useState(false);
  const [openExtend, setOpenExtend] = useState(false);
  const [address, setAddress] = useState(false);
  const [extendList, setExtendList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [rowIds, setRowIds] = useState([]);
  const [isRender, setIsRender] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: 'cbrq', direction: 'ascending' });
  const [page, setPage] = useState(0);
  const [hisRows, setHisRows] = useState([]);

  const currentCourseConfig = courseConfig[props?.kcdm || ''];

  // 推荐model
  const [showRecommend, setShowRecommend] = useState(false);

  const allSelected =
    selected.length > 0 && rowIds.every(id => selected.includes(id));
  const someSelected = selected.length > 0 && !allSelected;
  const [objInfo, setObjInfo] = useState({
    jcmc: '', // 书名
    type: '', //类型
    isbn: '', // isbn
    zzxm: '', // 作者姓名
    cbdw: '', // 出版单位
    cbrq: '', // 出版日期
    callno: '', // 索书号
    language: '', // 语种
    internalId: '',
    jcId: '', // 教参id
    bsId: '', // 课程id
    userId: '', // 用户id
    isTeacher: '', // 是否为老师
  });

  const getInitToken = () => {
    const paramsObj = search2query(props.location.search);
    if (paramsObj?.code) {
      instance({
        method: 'get',
        url: `oauth/getToken`,
        params: {
          code: paramsObj?.code,
        },
      }).then(res => {
        const { code, data, message: msg } = res?.data;
        switch (code) {
          case 0:
            console.log('获取的token', data);
            setToken(data);
            // 把code删掉 重新跳转
            let urlParams = window.location.href;
            let lastIndex = urlParams.lastIndexOf('&');
            let result = urlParams.substring(0, lastIndex);
            setTimeout(() => {
              window.location.href = result;
              window.location.reload();
            }, 0);
            break;
          default:
            console.log(msg);
            break;
        }
      });
      return;
    } else {
      fetchData();
    }
  };

  const getURLParams = () => {
    const paramsObj = search2query(props.location.search);
    if (
      paramsObj?.courseId &&
      paramsObj?.ghId &&
      paramsObj?.isTeacher &&
      paramsObj?.userId
    ) {
      console.log('222222s');
      localStorage.setItem('urlParams', JSON.stringify(paramsObj));
      setIsRender(true);
    } else {
      setIsRender(false);
      console.log('url参数不全', paramsObj);
      return;
    }
  };

  const fetchData = async () => {
    const paramsObj = search2query(props.location.search);

    getURLParams();

    setObjInfo({
      jcmc: '', // 书名
      type: '', //类型
      isbn: '', // isbn
      zzxm: '', // 作者姓名
      cbdw: '', // 出版单位
      cbrq: '', // 出版日期
      callno: '', // 索书号
      language: '', // 语种
      internalId: '',
      jcId: '', // 教参id
      bsId: paramsObj.courseId, // 课程id
      userId: paramsObj.userId, // 用户id
      isTeacher: paramsObj.isTeacher, // 是否为老师
    });
    setGhId(paramsObj.ghId);
    let bsid = paramsObj.courseId;
    if (bsid) {
      await instance({
        method: 'get',
        url: `searchThesisReference/${bsid}`,
      })
        .then(res => {
          console.log(res.headers['redirect']);
          if (res.data.code && res.data.code === 400 && res.data.message) {
            setObjInfo({
              jcmc: '', // 书名
              type: '', //类型
              isbn: '', // isbn
              zzxm: '', // 作者姓名
              cbdw: '', // 出版单位
              cbrq: '', // 出版日期
              callno: '', // 索书号
              language: '', // 语种
              internalId: '',
              jcId: '', // 教参id
              bsId: paramsObj.courseId, // 课程id
              userId: paramsObj.userId, // 用户id
              isTeacher: false, // 是否为老师
            });
            setMessage(res.data.message);
          }
          if (res.data.data) {
            setAddress(true);
            const responseData = res.data.data;
            const rowsArr = [];
            responseData.map((item, index) => {
              rowsArr.push(
                Object.assign(item, { number: index + 1 })
              );
              return item.id;
            });
            setRows(rowsArr);
            setRowsIds(rowsArr.map(i => i.id));
          }
        })
        .catch(() => {})
        .finally(() => {});
    }
  };

  useEffect(() => {
    getURLParams();

    getInitToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.search]);

  //  添加新教参
  const onAddNewReference = () => {
    let obj = objInfo;
    sessionStorage.setItem('paper_info', JSON.stringify(obj));
    props.history.push(
      `/searchPaper?userId=` +
        objInfo.userId +
        `&courseId=` +
        objInfo.bsId +
        `&isTeacher=` +
        objInfo.isTeacher+
        `&ghId=` +
        ghId
    );
  };
  // 查看全文
  const onReadMore = async rating => {
    instance({
      method: 'post',
      url: `addVisitLog`,
      data: {
        referenceInternalId: rating?.internalId,
        userId: objInfo.userId,
      },
    }).then(({ data }) => {
      console.log(data);
    });
    if (ghId && ghId !== '' && rating.id && rating.id !== '') {
      instance({
        method: 'get',
        url: `addLog?ghId=${ghId}&jcId=${rating.id}&bsid=${objInfo.bsId}`,
      })
        .then(res => {
          console.log('查看全文返回结果', res);
        })
        .catch(error => {
          console.log('全文错误', error);
        });
    }
  };

  // 编辑
  const onEdit = rating => {
    let obj = {
      ...rating,
      jcmc: rating.jcmc, // 书名
      type: rating.type, //类型
      isbn: rating.isbn, // isbn
      zzxm: rating.zzxm, // 作者姓名
      cbdw: rating.cbdw, // 出版单位
      cbrq: rating.cbrq, // 出版日期
      callno: rating.callno, // 索书号
      language: rating.language, // 语种
      internalId: rating.internalId,
      jcId: rating.id, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    };
    sessionStorage.setItem('paper_info', JSON.stringify(obj));
  };

  // 打开确认删除弹框
  const onOpen = rating => {
    setOpen(true);
    setObjInfo({
      ...objInfo,
      jcmc: objInfo.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: objInfo.isbn, // isbn
      zzxm: objInfo.zzxm, // 作者姓名
      cbdw: objInfo.cbdw, // 出版单位
      cbrq: objInfo.cbrq, // 出版日期
      callno: objInfo.callno, // 索书号
      language: objInfo.language, // 语种
      internalId: objInfo.internalId,
      jcId: rating.id, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    });
  };

  // 取消关闭删除弹框
  const onClose = () => {
    setOpen(false);
    setObjInfo({
      ...objInfo,
      jcmc: objInfo.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: objInfo.isbn, // isbn
      zzxm: objInfo.zzxm, // 作者姓名
      cbdw: objInfo.cbdw, // 出版单位
      cbrq: objInfo.cbrq, // 出版日期
      callno: objInfo.callno, // 索书号
      language: objInfo.language, // 语种
      internalId: objInfo.internalId,
      jcId: '', // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
    });
  };

  // 确定删除并关闭弹框
  const onDelete = () => {
    setOpen(false);
    let parameter = {
      jcid: objInfo.jcId,
      bsid: objInfo.bsId,
      status: 'disable',
    };
    const variants = ['success', 'error'];
    const politeness = ['删除成功', '删除失败'];
    const alert = [];
    instance({
      method: 'post',
      url: `updateKcJcRelation`,
      data: parameter,
    })
      .then(res => {
        if (res && res.data && res.data.message === 'SUCCESS') {
          //  删除成功后又查询一次以确保排序正确
          instance({
            method: 'get',
            url: `searchThesisReference/${objInfo.bsId}`,
          })
            .then(res => {
              const responseData = res.data.data;
              const rowsArr = [];
              responseData.map((item, index) => {
                rowsArr.push(
                  Object.assign(item, { number: index + 1 })
                );
                return item.id;
              });
              setRows(rowsArr);
              setRowsIds(rowsArr.map(i => i.id));
            })
            .catch(() => {});
          alert['politenessName'] = politeness[0];
          alert['variants'] = variants[0];
          setAlerts(alert);
          setAlertToggle('block');
          setTimeout(() => {
            setAlertToggle('none');
            setAlerts([]);
          }, 3000);
        }
      })
      .catch(() => {});
  };

  // 详情
  const onDetail = rating => {
    setObjInfo({
      ...rating,
      jcmc: rating.jcmc, // 书名
      type: objInfo.type, //类型
      isbn: rating.isbn, // isbn
      zzxm: rating.zzxm, // 作者姓名
      cbdw: rating.cbdw, // 出版单位
      cbrq: rating.cbrq, // 出版日期
      callno: rating.callno, // 索书号
      language: rating.language, // 语种
      internalId: objInfo.internalId,
      jcId: objInfo.jcId, // 教参id
      bsId: objInfo.bsId, // 课程id
      userId: objInfo.userId, // 用户id
      isTeacher: objInfo.isTeacher, // 是否为老师
      csx: rating.csx, // 丛书项
      ys: rating.ys, // 页数
      bb: rating.bb, // 版本
      abstractInfo: rating.abstractInfo, // 摘要
    });
    setOpenDetail(true);
  };

  //  关闭详情弹框
  const onCloseDetail = () => {
    setOpenDetail(false);
  };
  //  表格按钮
  const renderCondensedButton = rating => (
    <p style={{ display: 'flex', justifyContent: ' space-evenly' }}>
      {rating && rating.urlupdateflg === 2 ? (
        <Link href={rating.referenceUrl} as="a" target="_blank">
          <CondensedButton onClick={() => onReadMore(rating)}>
            查看全文
          </CondensedButton>
        </Link>
      ) : (
        <CondensedButton interaction="disabled">查看全文</CondensedButton>
      )}
      {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
        rating && rating.status === 1 && rating.modifyflg === 0 ? (
          <Link href="#/addPaper">
            <CondensedButton onClick={() => onEdit(rating)}>
              编辑
            </CondensedButton>
          </Link>
        ) : (
          <CondensedButton
            interaction="disabled"
            onClick={() => onEdit(rating)}
          >
            编辑
          </CondensedButton>
        )
      ) : (
        ''
      )}
      <CondensedButton onClick={() => onDetail(rating)}>详情</CondensedButton>
      {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
        <CondensedButton onClick={() => onOpen(rating)}>删除</CondensedButton>
      ) : (
        ''
      )}
    </p>
  );

  const headers = [
    {
      id: 'number',
      text: '序号',
      width: '5%',
      textAlign: 'center',
    },
    {
      id: 'orderNum',
      text: <>保障顺序<IconEditLine style={{ marginLeft: '10px' }} /></>,
      width: '10%',
      textAlign: 'start',
      isHidden: !objInfo?.isTeacher || objInfo?.isTeacher !== 'true',
      renderCell: rating => (
        <EditInput
          key={`EditInput_${rating?.id}`}
          orderNum={rating?.orderNum || 0}
          onSubmit={
            orderNum => {
              let parameter = {
                ...rating,
                orderNum,
              };
              const variants = ['success', 'error'];
              const politeness = ['修改成功', '修改失败'];
              const alert = [];
              instance({
                method: 'post',
                url: `updateReference`,
                data: parameter,
              })
                .then(res => {
                  if (res && res.data && res.data.id) {
                    //  修改成功后又查询一次以确保排序正确
                    fetchData();
                    alert['politenessName'] = politeness[0];
                    alert['variants'] = variants[0];
                    setAlerts(alert);
                    setAlertToggle('block');
                    setTimeout(() => {
                      setAlertToggle('none');
                      setAlerts([]);
                    }, 3000);
                  }
                })
                .catch(() => {});
            }
          }
        />
      ),
    },
    {
      id: 'jcmc',
      text: '名称',
      width: '18%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'cbdw',
      text: '来源',
      width: '7%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '时间卷期',
      width: '10%',
      textAlign: 'start',
    },
    // {
    //   id: 'urlupdateflg',
    //   text: '是否有电子版',
    //   width: '10%',
    //   textAlign: 'start',
    //   renderCell: rating => rating?.urlupdateflg === 2 ? '是' : '否',
    // },
    {
      id: 'action',
      text: '操作',
      width: '20%',
      textAlign: 'center',
      renderCell: rating => renderCondensedButton(rating),
    },
  ];
  const headers2 = [
    {
      id: 'resource',
      text: '类型',
      width: '10%',
      textAlign: 'start',
    },
    {
      id: 'jcmc',
      text: '标题',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'zzxm',
      text: '作者',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'cbdw',
      text: '来源',
      width: '20%',
      textAlign: 'start',
    },
    {
      id: 'cbrq',
      text: '时间卷期',
      width: '10%',
      textAlign: 'start',
      sortable: true,
    },
    {
      id: 'creatorNum',
      text: '添加人',
      width: '10%',
      textAlign: 'start',
      sortable: true,
    },
  ];

  useEffect(() => {
    if (extendList && extendList.length > 0) {
      const sortedList = [...extendList].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (aValue < bValue) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
      setHisRows(sortedList.slice(page * 10, (page + 1) * 10));
    } else {
      setHisRows([]);
    }
  }, [extendList, sortConfig, page]);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  return (
    <div>
      <div style={{ minHeight: 'calc(100% - 40px)' }}>
        {isRender && (
          <>
            {objInfo.isTeacher && objInfo.isTeacher === 'true' ? (
              <p style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>
                  <Button
                    color="primary"
                    margin="small"
                    onClick={() => {
                      console.log(objInfo.bsId);
                      instance({
                        method: 'post',
                        url: `searchSimilarKcReferenceByKcId`,
                        data: {
                          bsId: objInfo.bsId,
                          resource: '论文',
                        },
                      }).then(response => {
                        const arr = response?.data?.data?.map((i, index) => ({
                          ...i,
                          number: index + 1,
                        }));
                        setOpenExtend(true);
                        setExtendList(arr);
                        setRowIds(
                          response?.data?.data
                            ?.map(i => i.id)
                            .filter(i => !rowsIds.includes(i))
                        );
                        // setHisRows(arr.slice(page * 10, (page + 1) * 10));
                        console.log(response);
                      });
                    }}
                  >
                    +导入历史教参
                  </Button>

                  <Tooltip
                    renderTip="图书馆已有的这些电子教参可能与您的课程相关"
                    offsetY="10"
                    placement="bottom"
                  >
                    <Button
                      color="primary"
                      margin="small"
                      onClick={() => {
                        setShowRecommend(true);
                      }}
                    >
                      图书馆推荐的教参
                    </Button>
                  </Tooltip>
                  <Button
                    color="primary"
                    margin="small"
                    interaction={currentCourseConfig?.subjectAiUrl ? 'enabled' : 'disabled'}
                    onClick={() => {
                      if (currentCourseConfig?.subjectAiUrl) {
                        window.open(currentCourseConfig.subjectAiUrl, '_blank');
                      }
                    }}
                  >
                    学科AI知识库
                  </Button>
                  <Button
                    color="primary"
                    margin="small"
                    interaction={currentCourseConfig?.courseAiUrl ? 'enabled' : 'disabled'}
                    onClick={() => {
                      if (currentCourseConfig?.courseAiUrl) {
                        window.open(currentCourseConfig.courseAiUrl, '_blank');
                      }
                    }}
                  >
                    课程AI知识库
                  </Button>
                </span>
                
                <Button
                  color="primary"
                  margin="small"
                  onClick={() => onAddNewReference()}
                >
                  +添加新教参
                </Button>
              </p>
            ) : (
              <p>
                <Button
                  color="primary"
                  margin="small"
                  interaction={currentCourseConfig?.subjectAiUrl ? 'enabled' : 'disabled'}
                  onClick={() => {
                    if (currentCourseConfig?.subjectAiUrl) {
                      window.open(currentCourseConfig.subjectAiUrl, '_blank');
                    }
                  }}
                >
                  学科AI知识库
                </Button>
                <Button
                  color="primary"
                  margin="small"
                  interaction={currentCourseConfig?.courseAiUrl ? 'enabled' : 'disabled'}
                  onClick={() => {
                    if (currentCourseConfig?.courseAiUrl) {
                      window.open(currentCourseConfig.courseAiUrl, '_blank');
                    }
                  }}
                >
                  课程AI知识库
                </Button>
              </p>
            )}
            <div
              style={
                rows && rows.length === 0
                  ? { display: 'none' }
                  : { display: 'block', marginTop: '35px' }
              }
            >
              <Table caption="table">
                <Table.Head>
                  <Table.Row>
                    {(headers || []).map(({ id, text, width, textAlign, isHidden }) => isHidden ? '' : (
                      <Table.ColHeader
                        key={id}
                        id={id}
                        width={width}
                        textAlign={textAlign}
                      >
                        {text}
                      </Table.ColHeader>
                    ))}
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {(rows || []).map(row => {
                    return (
                      <Table.Row>
                        {headers.map(({ id, renderCell, textAlign, isHidden }) => isHidden ? '' : (
                          <Table.Cell
                            // key={row.id}
                            id={row.id}
                            textAlign={textAlign}
                          >
                            {renderCell ? renderCell(row) : row[id]}
                          </Table.Cell>
                        ))}
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
              
              <Modal open={open} size="small" label="Modal Dialog: 删除教参">
                <Modal.Header>
                  <p
                    style={{
                      textAlign: 'center',
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                    }}
                  >
                    删除教参
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <p style={{ marginLeft: '2%' }}>确认删除这条教参吗？</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button margin="0 x-small 0 0" onClick={() => onClose()}>
                    取消
                  </Button>
                  <Button color="primary" onClick={() => onDelete()}>
                    确定
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                open={openDetail}
                size="medium"
                label="Modal Dialog: 单册详情"
              >
                <Modal.Header>
                  <p
                    style={{
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                    }}
                  >
                    单册详情
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <div style={{ display: 'flex' }}>
                    <FormFieldGroup
                      description=""
                      layout="stacked"
                      rowSpacing="large"
                    >
                      <FormField layout="inline" label="论文标题:">
                        {objInfo.jcmc}
                      </FormField>
                      <FormField layout="inline" label="来源:">
                        {objInfo.cbdw}
                      </FormField>
                    </FormFieldGroup>
                    <FormFieldGroup
                      description=""
                      layout="stacked"
                      rowSpacing="large"
                    >
                      <FormField layout="inline" label="作者:">
                        {objInfo.zzxm}
                      </FormField>
                      <FormField layout="inline" label="时间卷期:">
                        {objInfo.cbrq}
                      </FormField>
                    </FormFieldGroup>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '28px' }}>
                    <div style={{width: '81px', textAlign: 'right'}}>
                      <Text weight='bold'>URL:</Text>
                    </div>
                    <div style={{width: 'calc(100% - 95px)'}}>
                      <FormField layout="inline" label="">
                        <Link href={objInfo.doi} target="_blank">
                           {objInfo.doi}
                        </Link>
                      </FormField>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '28px' }}>
                    <div style={{width: '81px', textAlign: 'right'}}>
                      <Text weight='bold'>摘要:</Text>
                    </div>
                    <div style={{width: 'calc(100% - 95px)'}}>
                      <FormField label='' ayout="inline">{objInfo.abstractInfo}</FormField>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="primary"
                    onClick={rating => onCloseDetail(rating)}
                  >
                    关闭
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                open={openExtend}
                size="large"
                label="Modal Dialog: 导入历史教参"
              >
                <Modal.Header>
                  <p
                    style={{
                      fontSize: '18px',
                      margin: '0px',
                      fontWeight: '700',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>导入历史教参<span style={{ color: 'red' }}>（论文）</span></span>
                    <Button
                      color="primary"
                      onClick={() => {
                        instance({
                          method: 'post',
                          url: `searchSimilarKcReferenceByGh`,
                          data: {
                            gh: ghId,
                            resource: '论文',
                          },
                        }).then(response => {
                          setPage(0);
                          const arr = response?.data?.data?.map((i, index) => ({
                            ...i,
                            number: index + 1,
                          }));
                          setExtendList(arr);
                        setRowIds(
                            response?.data?.data
                              ?.map(i => i.id)
                              .filter(i => !rowsIds.includes(i))
                          );
                          // setHisRows(arr.slice(0, 10));
                        });
                      }}
                    >
                      查看本人所有电子教参
                    </Button>
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <Table caption="table">
                    <Table.Head>
                      <Table.Row>
                        <Table.ColHeader id="select" width="10%">
                          <Checkbox
                            label=""
                            onChange={() => {
                              setSelected([
                                ...(allSelected ? new Set() : new Set(rowIds)),
                              ]);
                            }}
                            checked={allSelected}
                            indeterminate={someSelected}
                          />
                        </Table.ColHeader>
                        {(headers2 || []).map(
                          ({ id, text, width, textAlign, sortable }) => (
                            <Table.ColHeader
                              key={id}
                              id={id}
                              width={width}
                              textAlign={textAlign}
                              onRequestSort={sortable ? () => handleSort(id) : undefined}
                              sortDirection={sortConfig.key === id ? sortConfig.direction : 'none'}
                            >
                              {text}
                            </Table.ColHeader>
                          )
                        )}
                      </Table.Row>
                    </Table.Head>
                    <Table.Body>
                      {(hisRows || []).map(row => {
                        const rowSelected = selected.includes(row.id);
                        return (
                          <Table.Row key={row.id}>
                            <Table.RowHeader>
                              <Checkbox
                                label=""
                                disabled={rowsIds.includes(row.id)}
                                onChange={() => {
                                  const copy = new Set(selected);
                                  if (rowSelected) {
                                    copy.delete(row.id);
                                  } else {
                                    copy.add(row.id);
                                  }
                                  setSelected([...copy]);
                                }}
                                checked={rowSelected}
                              />
                            </Table.RowHeader>
                            {headers2.map(({ id, renderCell, textAlign }) => (
                              <Table.Cell
                                key={id}
                                id={id}
                                textAlign={textAlign}
                              >
                                {renderCell ? renderCell(row) : row[id]}
                              </Table.Cell>
                            ))}
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                  {
                    !extendList?.length && <p style={{ textAlign: 'center' }}>无历史教参</p>
                  }
                  <Pagination
                    variant="compact"
                    labelNext="Next Page"
                    labelPrev="Previous Page"
                    margin="large"
                  >
                    {Array.from(Array(Math.ceil(extendList?.length / 10)), (item, index) => (
                      <Pagination.Page
                        key={index}
                        onClick={() => handleChangePage(index)}
                        current={index === page}
                      >
                        {index + 1}
                      </Pagination.Page>
                    ))}
                  </Pagination>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="primary"
                    margin="0 x-small 0 0"
                    interaction={selected.length ? 'enabled' : 'disabled'}
                    onClick={() => {
                      instance({
                        method: 'post',
                        url: `inheritKcReference`,
                        data: {
                          kcId: objInfo.bsId,
                          referenceIdList: selected.map(i => `${i}`),
                        },
                      }).then(res => {
                        console.log(res);
                        const variants = ['success', 'error'];
                        const politeness = ['操作成功', '操作失败'];
                        const alert = [];
                        if (res?.data?.code === 0) {
                          setOpenExtend(false);
                          setSelected([]);
                          alert['politenessName'] = politeness[0];
                          alert['variants'] = variants[0];
                          fetchData();
                        } else {
                          alert['politenessName'] = politeness[1];
                          alert['variants'] = variants[1];
                        }
                        setAlerts(alert);
                        setAlertToggle('block');
                        setTimeout(() => {
                          setAlertToggle('none');
                          setAlerts([]);
                        }, 3000);
                      });
                    }}
                  >
                    确定
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      setOpenExtend(false);
                      setSelected([]);
                    }}
                  >
                    关闭
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
            <div
              style={
                alertToggle && alertToggle === 'block'
                  ? {
                      display: 'block',
                      zIndex: '99',
                      position: 'fixed',
                      width: '30%',
                      bottom: '0',
                      right: '2% ',
                    }
                  : { display: 'none' }
              }
            >
              {
                <Alert
                  variant={alerts.variants}
                  margin="small"
                  renderCloseButtonLabel="Close"
                >
                  {alerts.politenessName}
                </Alert>
              }
            </div>
            <div
              style={
                rows && rows.length === 0
                  ? { display: 'block', marginTop: '35px' }
                  : { display: 'none' }
              }
            >
              <View
                as="div"
                maxHeight="100%"
                textAlign="center"
                margin="large"
                padding="large"
                position="relative"
              >
                <span
                  style={{
                    color: '#8FBFDA',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontSize: '28px',
                  }}
                >
                  该课程尚未添加教参！
                </span>
                <img
                  src={imgURL}
                  alt=""
                  style={{ display: 'block', margin: '0 auto' }}
                />
              </View>
            </div>
            <div
              style={
                message && message !== ''
                  ? { display: 'block', marginTop: '35px' }
                  : { display: 'none' }
              }
            >
              <View
                as="div"
                maxHeight="100%"
                textAlign="center"
                margin="large"
                padding="large"
                position="relative"
              >
                <span
                  style={{
                    color: '#666666',
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontSize: '28px',
                  }}
                >
                  {message}
                </span>
              </View>
            </div>
          </>
        )}
      </div>

      <RecommendedThesis
        open={showRecommend}
        bsId={objInfo.bsId}
        ghId={ghId}
        selectedIdList={rowsIds}
        onCancel={() => setShowRecommend(false)}
        onSubmit={referenceList => {
          instance({
            method: 'post',
            url: `addKcAndReferenceBatch`,
            data: {
              kcId: objInfo.bsId,
              gh: ghId,
              referenceList,
            },
          }).then(res => {
            console.log(res);
            const variants = ['success', 'error'];
            const politeness = ['操作成功', '操作失败'];
            const alert = [];
            if (res?.data?.code === 0) {
              setShowRecommend(false);
              alert['politenessName'] = politeness[0];
              alert['variants'] = variants[0];
              fetchData();
            } else {
              alert['politenessName'] = politeness[1];
              alert['variants'] = variants[1];
            }
            setAlerts(alert);
            setAlertToggle('block');
            setTimeout(() => {
              setAlertToggle('none');
              setAlerts([]);
            }, 3000);
          });
        }}
      />

      {address && <EmailInfo />}
    </div>
  );
}
export default GuidePapers;
